import { authPut } from "@api";

export const putAcceptedTOC = (hasAccepted: boolean) => {
  return authPut<{ has_accepted_toc: boolean }, string>("/api/user/toc", {
    has_accepted_toc: hasAccepted,
  });
};
